import gql from 'graphql-tag';

const GET_AUDIENCE_DEMOGRAPHS = gql`
  query audienceDemographs($whereParameters: AudienceDemographWhereInput!) {
    audienceDemographs(first: 1000, orderBy: createdAt_DESC, where: $whereParameters) {
      id
      name
      description
      tags
      metrics
      reachCount
      createdAt
      isArchived
      isPushedToS3MJ
      isPushedToS3Statara
      isPublished
      audienceId
      s3MJDetails
      prePublishedMetadata
      publishedDate
      createdBy {
        id
        name
      }
    }
  }
`;

export default GET_AUDIENCE_DEMOGRAPHS;
